import Vue from 'vue'
import App from './App.vue'
import './assets/js/flexible'
import './assets/js/TweenMax.min'
import './assets/js/sound'
import router from './router'
import store from './store'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueTouch from 'vue-touch'
import api from './api'

Vue.use(vueSwiper)
Vue.use(VueTouch)
// Vue.use(ElementUI)

Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.prototype.$baseUrl = ''
// http://fun.guangxifxj.cn

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
